export const INITIAL_DATA_STATE = 'data-state/initial';
export const SUCCESS_DATA_STATE = 'data-state/success';
export const ERROR_DATA_STATE = 'data-state/error';
export const LOADING_DATA_STATE = 'data-state/loading';

export const dataStates = [
    INITIAL_DATA_STATE,
    SUCCESS_DATA_STATE,
    ERROR_DATA_STATE,
    LOADING_DATA_STATE,
] as const;

export type DataState = (typeof dataStates)[number];

export const ERROR_NOT_LANDSCAPE_DATA_STATE = 'data-state/not-landscape';
export const ERROR_TOO_LARGE_DATA_STATE = 'data-state/too-large';
export const WARNING_INCORRECT_DIMENSIONS_DATA_STATE =
    'data-state/incorrect-dimensions';

export type FileDataState =
    | DataState
    | typeof ERROR_NOT_LANDSCAPE_DATA_STATE
    | typeof ERROR_TOO_LARGE_DATA_STATE
    | typeof WARNING_INCORRECT_DIMENSIONS_DATA_STATE;
